import { render, staticRenderFns } from "./AddHeaderFooter.vue?vue&type=template&id=0ad857e6"
import script from "./AddHeaderFooter.vue?vue&type=script&lang=js"
export * from "./AddHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports